import script from "./PokemonDetailsModalComposition.vue?vue&type=script&setup=true&lang=js"
export * from "./PokemonDetailsModalComposition.vue?vue&type=script&setup=true&lang=js"

import "./PokemonDetailsModalComposition.vue?vue&type=style&index=0&id=3bbbf8a4&lang=scss"

const __exports__ = script;

export default __exports__